
/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

function TkDeliveryAvailableOrderBuyerDetail(props) {

  const { onSelect, onDetailInitialized, onDetailApiInitialized } = props;

  const { t } = useTranslation ();

  const [api, setApi] = useState();

  useEffect(()=>{

    if ( api ) {

        api.refresh ();

    }

  },[onSelect])

  const onApiInitialized = ( api ) => {

    if(onDetailApiInitialized) {

      onDetailApiInitialized(api);
      
    }

    setApi ( api );

  };

  const onInitialized = (grid) => {

    grid.selectionMode = "Row"

    onDetailInitialized(grid);

  }
  
  return (
      <BasicCrudScreenType
                id="TkVwDeliveryAvailableOrderBuyerDetail"
                embededInOtherScreenType
                view= "TkVwDeliveryAvailableOrderBuyerDetail"
                headerTitle={t("term.soDetail")}
                noExcel
                onModifyViewUrl = {(url) => `${url}/${onSelect?.orderBuyerId}`}
                onApiInitialized = {onApiInitialized}
                onInitialized = {onInitialized}
            />

  );
}

export default TkDeliveryAvailableOrderBuyerDetail;
